import axios from 'axios';

/**
 * @param {{ hspId:string, mpiKey:string, receivePaymentId:string, medicalInsuranceType:string }} params
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export const getPayReceipt = async (params) => {
  const { hspId, mpiKey, receivePaymentId, medicalInsuranceType } = params;
  const baseUrl = process.env.REACT_APP_API_DFD_SVC_URL?.trim() || '';

  const url = `${baseUrl}/dfd/api/if/web/v1/pay-receipt/${hspId}/${mpiKey}/${receivePaymentId}?medicalInsuranceType=${medicalInsuranceType}`;

  try {
    return await axios.get(url);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`진료비 영수증 조회 실패: ${error.message}`);
    }
    throw error;
  }
};

/**
 * @param {{ hspId:string, mpiKey:string, functionType:string, detailFunctionType:string }} params
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export const postStatisticsReceiptDownload = async (params) => {
  const { hspId, mpiKey, functionType, detailFunctionType, result } = params;

  const baseUrl = process.env.REACT_APP_API_DFD_SVC_URL?.trim() || '';

  const url = `${baseUrl}/dfd/api/if/web/v1/stts`;

  return await axios.post(url, {
    hspId,
    mpiKey,
    functionType,
    detailFunctionType,
    result,
  });
};
